import DealersLayout from "../containers/DealersLayout/index";
import ContractsLayout from "../containers/ContractsLayout/index";
import CustomersLayout from "../containers/CustomersLayout/index";
import StaffLayout from "../containers/StaffLayout/index";
import Settings from "../containers/Settings/index";
// import ProductsLayout from "../containers/ProductsLayout";

const appRoutes = [
  {
    path: "/dealers",
    name: "Dealers",
    icon: "pe-7s-network",
    component: DealersLayout,
    roles: ["staff"]
  },
  {
    path: "/contracts",
    name: "Contracts",
    icon: "pe-7s-note2",
    component: ContractsLayout,
    roles: ["staff", "customer", "contact"]
  },
  // {
  //   path: "/orders",
  //   name: "Orders",
  //   icon: "pe-7s-box1",
  //   roles: ["staff", "customer"]
  // },
  {
    path: "/staff",
    name: "Staff",
    icon: "pe-7s-id",
    component: CustomersLayout,
    roles: ["staff"]
  },
  {
    path: "/customers",
    name: "Customers",
    icon: "pe-7s-user",
    component: StaffLayout,
    roles: ["staff"]
  },
  // {
  //   path: "/products",
  //   name: "Products",
  //   icon: "pe-7s-shopbag",
  //   component: ProductsLayout,
  //   roles: ["staff", "customer"]
  // },
  // {
  //   path: "/shopping-cart",
  //   name: "Shopping Cart",
  //   icon: "pe-7s-cart",
  //   roles: ["customer"]
  // },
  {
    path: "/settings",
    name: "Settings",
    icon: "pe-7s-config",
    component: Settings,
    roles: ["staff", "customer"]
  }
];

export default appRoutes;
